"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeatherAt12 = exports.WeatherAt7 = void 0;
var React = require("react");
var react_select_1 = require("react-select");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
require("./style.scss");
var getTemperatureOptions = function (start, end) {
    var arrayOfTemps = Array.from(Array(end - start + 1).keys()).map(function (x) {
        if (x + start > 0) {
            return { value: "+".concat(x + start), label: "+".concat(x + start) };
        }
        return { value: "".concat(x + start), label: "".concat(x + start) };
    });
    arrayOfTemps.sort(function (a, b) {
        if (a.value === '0') {
            return -1;
        }
        if (b.value === '0') {
            return 1;
        }
        if (a.value.charAt(0) === '+' && b.value.charAt(0) !== '+') {
            return -1;
        }
        if (a.value.charAt(0) !== '+' && b.value.charAt(0) === '+') {
            return 1;
        }
        return Math.abs(parseInt(a.value, 10)) - Math.abs(parseInt(b.value, 10)) < 0
            ? -1
            : 1;
    });
    var arrayOfTempsWithNull = [{ label: '\0', value: '' }].concat(arrayOfTemps);
    return arrayOfTempsWithNull;
};
var convertTempToString = function (temp) {
    if (temp === null || isNaN(temp)) {
        return '';
    }
    if (temp > 0) {
        return "+".concat(temp);
    }
    return temp.toString();
};
var tempOptions = getTemperatureOptions(-50, 50);
var WeatherAt7 = function (props) {
    if (!props.isEditable) {
        return (React.createElement("div", { className: "card-box-field" },
            React.createElement(sok_ui_1.Column, { large: 12 },
                React.createElement(React.Fragment, null,
                    React.createElement("b", null, (0, translation_1.getLocalization)('diaryEntryView/weather/temperature')),
                    ":",
                    ' ',
                    React.createElement("span", null, props.weatherInfo && props.weatherInfo.tempAt7 !== undefined
                        ? convertTempToString(props.weatherInfo.tempAt7)
                        : '-'))),
            React.createElement(sok_ui_1.Column, { large: 12 },
                React.createElement(React.Fragment, null,
                    React.createElement("b", null, (0, translation_1.getLocalization)('diaryEntryView/weather/conditions')),
                    ":",
                    ' ',
                    React.createElement("span", null, props.weatherInfo && props.weatherInfo.conditionAt7
                        ? (0, translation_1.getLocalization)("diaryEntryView/weatherCondition/".concat(props.weatherInfo.conditionAt7))
                        : '-'))),
            React.createElement(sok_ui_1.Column, null,
                React.createElement(React.Fragment, null,
                    React.createElement("b", null, (0, translation_1.getLocalization)('diaryEntryView/weather/disturbance')),
                    ":",
                    ' ',
                    React.createElement("span", null, props.weatherInfo &&
                        props.weatherInfo.disturbanceAt7 !== undefined &&
                        props.weatherInfo.disturbanceAt7
                        ? (0, translation_1.getLocalization)('global/yes')
                        : (0, translation_1.getLocalization)('global/no'))))));
    }
    return (React.createElement("div", { className: "card-box-field" },
        React.createElement(sok_ui_1.Column, { large: 12 },
            React.createElement(React.Fragment, null,
                React.createElement("label", { htmlFor: 'weatherTemperature' }, (0, translation_1.getLocalization)('diaryEntryView/weather/temperature')),
                React.createElement(react_select_1.default, { menuPlacement: 'auto', menuPortalTarget: props.menuPortalTarget, isSearchable: true, isDisabled: props.isDisabled, classNamePrefix: "react-select", options: tempOptions, value: props.weatherInfo && props.weatherInfo.tempAt7 !== undefined
                        ? {
                            label: convertTempToString(props.weatherInfo.tempAt7),
                            value: props.weatherInfo.tempAt7
                                ? props.weatherInfo.tempAt7.toString()
                                : ''
                        }
                        : { label: '', value: '' }, isClearable: false, onChange: function (e) {
                        props.setWeatherInfo(__assign(__assign({}, props.weatherInfo), { tempAt7: parseInt(e.value, 10) }));
                    } }))),
        React.createElement(sok_ui_1.Column, { large: 12 },
            React.createElement(React.Fragment, null,
                React.createElement("label", { htmlFor: 'weatherConditions' }, (0, translation_1.getLocalization)('diaryEntryView/weather/conditions')),
                React.createElement(react_select_1.default, { menuPlacement: 'auto', menuPortalTarget: props.menuPortalTarget, isSearchable: true, isDisabled: props.isDisabled, classNamePrefix: "react-select", id: 'weatherConditions7', value: props.weatherInfo && props.weatherInfo.conditionAt7
                        ? {
                            label: (0, translation_1.getLocalization)("diaryEntryView/weatherCondition/".concat(props.weatherInfo.conditionAt7)),
                            value: props.weatherInfo.conditionAt7
                        }
                        : {
                            label: '',
                            value: ''
                        }, options: props.weatherCondition, onChange: function (e) {
                        props.setWeatherInfo(__assign(__assign({}, props.weatherInfo), { conditionAt7: e.value.toString() }));
                    } }))),
        React.createElement(sok_ui_1.Column, null,
            React.createElement(sok_ui_1.Input, { className: "weatherdisturbance", id: 'weatherDisturbance7', type: 'checkbox', disabled: props.isDisabled, defaultChecked: props.weatherInfo && props.weatherInfo.disturbanceAt7, label: (0, translation_1.getLocalization)('diaryEntryView/weather/disturbance'), onChange: function (e) {
                    props.setWeatherInfo(__assign(__assign({}, props.weatherInfo), { disturbanceAt7: e.target.checked }));
                } }))));
};
exports.WeatherAt7 = WeatherAt7;
var WeatherAt12 = function (props) {
    if (!props.isEditable) {
        return (React.createElement("div", { className: "card-box-field" },
            React.createElement(sok_ui_1.Column, { large: 12 },
                React.createElement(React.Fragment, null,
                    React.createElement("b", null, (0, translation_1.getLocalization)('diaryEntryView/weather/temperature')),
                    ":",
                    ' ',
                    React.createElement("span", null, props.weatherInfo && props.weatherInfo.tempAt12 !== undefined
                        ? convertTempToString(props.weatherInfo.tempAt12)
                        : '-'))),
            React.createElement(sok_ui_1.Column, { large: 12 },
                React.createElement(React.Fragment, null,
                    React.createElement("b", null, (0, translation_1.getLocalization)('diaryEntryView/weather/conditions')),
                    ":",
                    ' ',
                    React.createElement("span", null, props.weatherInfo && props.weatherInfo.conditionAt12
                        ? (0, translation_1.getLocalization)("diaryEntryView/weatherCondition/".concat(props.weatherInfo.conditionAt12))
                        : '-'))),
            React.createElement(sok_ui_1.Column, null,
                React.createElement(React.Fragment, null,
                    React.createElement("b", null, (0, translation_1.getLocalization)('diaryEntryView/weather/disturbance')),
                    ":",
                    ' ',
                    React.createElement("span", null, props.weatherInfo &&
                        props.weatherInfo.disturbanceAt12 !== undefined &&
                        props.weatherInfo.disturbanceAt12
                        ? (0, translation_1.getLocalization)('global/yes')
                        : (0, translation_1.getLocalization)('global/no'))))));
    }
    return (React.createElement("div", { className: "card-box-field" },
        React.createElement(sok_ui_1.Column, { large: 12 },
            React.createElement(React.Fragment, null,
                React.createElement("label", { htmlFor: 'weatherTemperature' }, (0, translation_1.getLocalization)('diaryEntryView/weather/temperature')),
                React.createElement(react_select_1.default, { menuPlacement: 'auto', menuPortalTarget: props.menuPortalTarget, isSearchable: true, isDisabled: props.isDisabled, classNamePrefix: "react-select", id: 'weatherTemperature12', value: props.weatherInfo && props.weatherInfo.tempAt12 !== undefined
                        ? {
                            label: convertTempToString(props.weatherInfo.tempAt12),
                            value: props.weatherInfo.tempAt12
                                ? props.weatherInfo.tempAt12.toString()
                                : ''
                        }
                        : { label: '', value: '' }, options: tempOptions, onChange: function (e) {
                        props.setWeatherInfo(__assign(__assign({}, props.weatherInfo), { tempAt12: parseInt(e.value, 10) }));
                    } }))),
        React.createElement(sok_ui_1.Column, { large: 12 },
            React.createElement(React.Fragment, null,
                React.createElement("label", { htmlFor: 'weatherConditions' }, (0, translation_1.getLocalization)('diaryEntryView/weather/conditions')),
                React.createElement(react_select_1.default, { menuPlacement: 'auto', menuPortalTarget: props.menuPortalTarget, isSearchable: true, isDisabled: props.isDisabled, classNamePrefix: "react-select", id: 'weatherConditions12', value: props.weatherInfo && props.weatherInfo.conditionAt12
                        ? {
                            label: (0, translation_1.getLocalization)("diaryEntryView/weatherCondition/".concat(props.weatherInfo.conditionAt12)),
                            value: props.weatherInfo.conditionAt12
                        }
                        : { label: '', value: '' }, options: props.weatherCondition, onChange: function (e) {
                        props.setWeatherInfo(__assign(__assign({}, props.weatherInfo), { conditionAt12: e.value }));
                    } }))),
        React.createElement(sok_ui_1.Column, null,
            React.createElement(sok_ui_1.Input, { className: "weatherdisturbance", id: 'weatherDisturbance12', type: 'checkbox', disabled: props.isDisabled, defaultChecked: props.weatherInfo && props.weatherInfo.disturbanceAt12, label: (0, translation_1.getLocalization)('diaryEntryView/weather/disturbance'), onChange: function (e) {
                    props.setWeatherInfo(__assign(__assign({}, props.weatherInfo), { disturbanceAt12: e.target.checked }));
                } }))));
};
exports.WeatherAt12 = WeatherAt12;
